import httpClient from './httpClient'

export default {
  getAll() {
    return httpClient.get('customers').then(r => r.data)
  },
  get(id) {
    return httpClient.get(`customers/${id}`).then(r => r.data)
  },
  create(payload) {
    return httpClient.post('customers', payload).then(r => r.data)
  },
  update(payload) {
    return httpClient.put('customers', payload).then(r => r.data)
  },
  remove(id) {
    return httpClient.delete(`customers/${id}`).then(r => r.data)
  }
}
